import RangeOfNumber from '@/commons/wildcards/constants/RangeOfNumber';
import i18nHelpLink from '@/i18ns/vi/i18nHelpLink';

export default {
  Search: {
    SearchPlaceHolder: 'Tìm kiếm',
    AddButton: 'Thêm mới',
    AddButtonShortKey: 'Thêm mới (F9)',
    SubmitButton: 'Chọn',
    SubmitButtonShortKey: 'Chọn (Ctrl + S)',
    CancelButton: 'Hủy',
  },
  Validate: {
    ExistDictionary: 'Danh mục {0} không tồn tại. Vui lòng kiểm tra lại.', // Danh mục không tồn tại
    Duplicate: '{0} đã tồn tại trong hệ thống. Vui lòng kiểm tra lại.',
    DuplicateRestore: '{0} đã tồn tại. Bạn có muốn chương trình tự động tăng số chứng từ không?',
    DuplicateName: '{0} đã bị trùng trong danh sách nhập. Vui lòng kiểm tra lại.',
    EditVersion: 'Dữ liệu đã bị thay đổi bởi người dùng khác. Xin vui lòng nạp lại.',
    DeleteMultiHasMultiArisened: 'Có một số bản ghi xuất hiện lỗi trong quá trình xóa.', // Chi tiết xem phía dưới: "[ {0} ]
    DeleteMultiHasMultiArisened2: 'Có một số bản ghi đã có phát sinh. Không thể xóa.',
    ConfirmDeleteMultiHasMultiArisened: 'Có một số bản ghi đã có phát sinh. Bạn có muốn tiếp tục xóa không?',
    DeleteMultiHasOneArisened: 'Có một bản ghi đã có phát sinh. Không thể xóa.', //<{0}>
    DeleteMultiHasOneArisenedComponentAsset: 'Linh kiện đã có phát sinh, bạn không thể xóa.', //<{0}>
    NotPermission: 'Bạn không có quyền thực hiện chức năng này. Vui lòng kiểm tra lại quyền của bạn.',
    TitleNotPermission: 'Không được phân quyền',
    ManagerUnitHasArise: 'Đơn vị quản lý đã có phát sinh dữ liệu, bạn không thể bỏ check là đơn vị quản lý.',
    ParentUnitHasArise:
      'Đơn vị quản lý cấp cha của đơn vị này đã có phát sinh dữ liệu đã, bạn không thể đặt là đơn vị quản lý.',
    ManagerUnitHasDependent:
      'Đơn vị đã có phát sinh đơn vị con là đơn vị quản lý, bạn không thể bỏ check là đơn vị quản lý.',
    NewMessageDelete: '{0} <{1}> đã có phát sinh. Bạn có muốn tiếp tục xóa không?',
    Required: 'Nhập thiếu thông tin {0}.',
    Arise:
      '{0} tổng hợp đã phát sinh dữ liệu. Do vậy, để thêm mới được <span class="color-green">{1}</span> , hệ thống phải chuyển toàn bộ dữ liệu gắn với {0} <span class="color-green">{2}</span> sang cho {0} <span class="color-green">{1}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    AriseAccount:
      'Hệ thống không cho phép hạch toán vào TK tổng hợp. Do vậy, để thêm mới TK <span class="color-green">{1}</span>, hệ thống phải chuyển toàn bộ dữ liệu gắn với TK <span class="color-green">{2}</span> sang TK <span class="color-green">{1}</span>. Bạn có muốn thực hiện việc chuyển đổi không?',
    StartThanEndDate: 'Ngày kết thúc phải lớn hơn Ngày bắt đầu.',
    Delete_ErrorIsPostedVoucher: 'Chứng từ này có liên quan đến chứng từ {0}. Bạn có muốn xóa không?',
    StartWithOther: 'Số tài khoản chi tiết không được bắt đầu bằng số hiệu của tài khoản con cùng cấp.',
    DuplicateTaxCode: '{0} đã tồn tại trong danh mục Khách hàng, nhà cung cấp. Bạn có muốn cất không?',
  },
  Detail: {
    SubmitError: 'Đã có lỗi xảy ra, vui lòng liên hệ với MISA để được hỗ trợ.',
    AddDetail: 'Thêm dòng',
    SaveSuccessMessage: 'Cất dữ liệu thành công',
  },
  Message: {
    ConfirmDeleteTitle: 'Xóa {0}',
    ConfirmDeleteVoucherTitle: 'Xóa chứng từ',
    ConfirmDeleteVoucher: 'Bạn có muốn xóa chứng từ <span class="color-green">{0}</span> không?',
    ConfirmDelete: 'Bạn có muốn xóa {0} <span class="color-green">{1}</span> không?',
    ConfirmDeleteMuti: 'Bạn có chắc chắn muốn xóa các bản ghi {0} được chọn không?',
    ConfirmDeleteMutiDictionary:
      'Bạn có chắc chắn muốn xóa các bản ghi <span class="color-green">{0}</span> được chọn không?',
    ConfirmDeleteUser: 'Bạn có thực sự muốn xóa {0} <span class="color-green">{1}</span> không?',
    ConfirmDeleteMultiUser: 'Bạn có thực sự muốn xóa những {0} đã chọn không?',
    ConfirmSaveChangeClose: 'Bạn có muốn Cất không?',
    ConfirmSaveChangeCloseCCDC: 'Dữ liệu đã bị thay đổi, bạn có muốn cất không?',
    NotSelected: 'Vui lòng chọn <span class="color-green">ít nhất 1 bản ghi</span> để thực hiện được chức năng này.',
    Exception: 'Đã có lỗi xảy ra, vui lòng liên hệ với MISA để được hỗ trợ.',
    ExportSuccess: 'Xuất khẩu thành công',
    DeleteSuccess: 'Xóa thành công',
    RejectSuccess: 'Từ chối duyệt thành công',
    SendApprovalSuccess: 'Gửi duyệt hồ sơ giao dịch KBNN thành công!',
    ApprovalSuccess: 'Ký duyệt hồ sơ giao dịch KBNN thành công!',
    WarningTitle: 'Cảnh báo',
    SaveSuccess: 'Cất thành công',
    PostedSuccess: 'Ghi sổ thành công',
    SavePostedSuccess: 'Cất và ghi sổ thành công',
    UnPostedSuccess: 'Bỏ ghi sổ thành công',
    Developing: 'Chức năng đang được phát triển.',
    DeleteWarningTitle: 'Không thể xóa',
    WarningBatchExcution: 'Không hợp lệ',
    ValidateInvalidTitle: 'Không hợp lệ',
    ValidateInvalidAccountTitle: 'Số tài khoản không hợp lệ',
    FailSave: 'Cất không thành công',
    FailSaveRealNameTitle: 'Chưa xác định đích danh chứng từ nhập',
    ArrriseAccount: 'Tài khoản đã có phát sinh',
    ArrriseOpeningAccount: 'Tài khoản đã có số dư ban đầu',
    ValidateBusinessTitle: 'Chứng từ không hợp lệ',
    ValidateBusiness: 'Vui lòng nhập ít nhất một dòng chứng từ chi tiết.',
    ValidateNotTyping: 'Vui lòng nhập ít nhất một dòng dữ liệu chi tiết.', // modified: vqphong - 27.10.2022
    ErrorSystemDeleteMulti: '{0} đã chọn là dữ liệu thuộc hệ thống.',
    ConfirmErrorSystemDelete: '{0} <span class="color-green">{1}</span> đã chọn là dữ liệu thuộc hệ thống.',
    ConfirmErrorDeleteTitle: 'Không thể xóa',
    WarningIncurredDataTitle: 'Xóa không thành công',
    WarningIncurredDataContent:
      '{0} <span class="color-green">{1}</span> đã có phát sinh dữ liệu. Bạn phải xóa các phát sinh liên quan trước khi xóa <span class="color-green">{2}</span>.',
    WarningIncurredDataContentCustom:
      '{0} <span class="color-green">{1}</span> đã có số dư ban đầu; đã phát sinh trên các chứng từ. Bạn phải xóa các phát sinh liên quan trước khi sửa thông tin chi tiết theo.',
    WarningArriseAccount:
      '{0} <span class="color-green">{1}</span> đã phát sinh trên các chứng từ. Bạn có muốn thay đổi không?',
    WarningArriseOpeningAccount:
      '{0} <span class="color-green">{1}</span> đã có số dư ban đầu. Bạn phải xóa số dư ban đầu trước khi sửa thông tin chi tiết theo.',
    WarningParallelNotValidRule: `<div class="content-toast"><div class="text-toast">Không tự động sinh được hạch toán đồng thời. <a class="help-view-here" href="${i18nHelpLink.AccountParallelRule}" target="_blank">Xem hướng dẫn</a></br>hoặc kiểm tra lại quy tắc <a id="accountParallelRule" class="help-view-here">Thiết lập hạch toán đồng thời</a>.</div><div class="icon-close"></div></div>`,

    WarningParallelNotAutoGenerate:
      'Thông tin hạch toán đồng thời không phù hợp với quy tắc thiết lập hạch toán đồng thời. Bạn có muốn cập nhật hạch toán đồng thời không?',

    DeleteRelation:
      'Chứng từ số <span class="color-green">{0}</span> có liên quan đến chứng từ số <span class="color-green">{1}</span>. Bạn có muốn xóa chứng từ liên quan này không?',
    DeleteRelations:
      'Chứng từ <span class="color-green">{0}</span> có liên quan đến chứng từ <span class="color-green">{1}</span>. Bạn có muốn xóa chứng từ liên quan này không?',
    DeleteRelationVoucherSummary:
      'Bảng tổng hợp này đã được kê trong Chứng từ ghi sổ <span class="color-green">&lt;{0}&gt;</span>, ',
    DeleteRelationVoucherSummaryMulti:
      '- Bảng tổng hợp <span class="color-green">&lt;{1}&gt;</span> đã được kê trong Chứng từ ghi sổ <span class="color-green">&lt;{0}&gt;</span> </br>',
    ConfirmDeleteRelationVoucherSummaryMulti:
      'Chương trình sẽ loại bỏ các bảng tổng hợp dưới đây ra khỏi chứng từ ghi sổ, bạn có thực sự muốn xóa không? </br>',
    ConfirmDeleteRelationVoucherSummary:
      'chương trình sẽ loại bỏ bảng tổng hợp này ra khỏi chứng từ ghi sổ, bạn có thực sự muốn xóa không?',
    DeleteRelationTitle: 'Xóa chứng từ',
    DeleteRelationMulti:
      'Chứng từ số <span class="color-green">{0}</span> có liên quan đến chứng từ số <span class="color-green">{1}</span>. </br>',
    ConfirmDeleteRelation: 'Bạn có muốn xóa chứng từ liên quan này không?',
    GetDefaultSettingLayoutSuccess: 'Lấy tùy chỉnh giao diện mặc định thành công',
    OverloadUpdate: `Tổng {0} trên thông tin chung, không cập nhật được do Tổng {0} theo nguồn vượt quá ${RangeOfNumber.MaxCountNumber} ký tự.`,
    TitleChangePostedDate: 'Chuyển năm hạch toán',
    ContentChangePostedDate:
      'Năm hạch toán vừa chuyển sang năm <span class="color-green">{0}</span> nên sẽ không thấy các chứng từ của năm cũ. Để xem lại các chứng từ của năm cũ, vui lòng chuyển lại ngày hạch toán.',
    ValidateOutwardQuantityTitle: 'Xuất kho quá số lượng tồn kho',
    ValidateOutwardQuantityContent:
      'Không thể xuất Vật tư <span class="color-green">{0}-{1}</span> quá số tồn trong kho <span class="color-green">{2}-{3}</span>. Số tồn tính đến ngày {4}: {5}. Ghi sổ không thành công.',
    ValidateOutwardQuantityRealNameContent:
      'Không thể xuất Vật tư <span class="color-green">{0}-{1}</span> quá số lượng tồn của chứng từ <span class="color-green">{2}</span>. Số lượng tồn của chứng từ <span class="color-green">{2}</span> là: {3}. Ghi sổ không thành công.',
    ValidateZeroQuantityRealNameContent:
      'Số tồn của Vật tư <span class="color-green">{0}-{1}</span> = 0. Vui lòng chọn Vật tư khác.',
    ValidateNotChooseInventoryRealNameContent: 'Vui lòng chọn Mã hàng trước khi chọn chứng từ Mua, Nhập VTHH.',
    ValidateUndefinedVoucherRealNameContent:
      'Vật tư <span class="color-green">{0}-{1}</span> chưa xác định đích danh chứng từ nhập. Cất không thành công.',
    ExpireReportDrillDown: 'Báo cáo cũ đã hết hạn, vui lòng in lại báo cáo.',
    TimeoutStockPrice:
      'Quá trình tính giá xuất kho có thể kéo dài phụ thuộc vào độ lớn của dữ liệu. Trong thời gian tính giá bạn vẫn có thể làm việc trên phần mềm. Để tránh sai sót bạn không nên sửa chứng từ thuộc kỳ tính giá.<br>Khi quá trình tính giá hoàn thành, hệ thống sẽ gửi kết quả trên chức năng <b>Thông báo</b>.',
    StockPriceRequest: 'Yêu cầu tính giá xuất kho',
    ConfirmDeleteReportTitle: 'Xóa báo cáo',
    ConfirmDeleteReport: 'Bạn có muốn xóa báo cáo này không?',
    ReplacementInvoiceExists:
      'Hóa đơn <span class="color-blue">{0} - {1} - {2}</span> đã được lập hóa đơn thay thế. Vui lòng kiểm tra lại.',

    WarningNoDataWhenSaveDvcFile:
      '<div class="content-toast"><div class="text-toast">Chưa chọn mẫu chứng từ thanh toán. <a class="link-view-here ml-2">Thêm mẫu chứng từ</a>.</div><div class="icon-close"></div></div>',
    TaxRateCheckTitle: 'Thuế suất không hợp lệ',
    TaxRateCheckContent:
      '<span class="color-green">Thuế suất</span> không đúng. Vui lòng chọn <span class="color-green">Thuế suất</span> có trong danh sách.',
    WarningNodataBudgetFees: 'Chưa phát sinh số liệu thực hiện thu Phí, lệ phí.',
    ErrorBudgetFees:
      'Vui lòng thực hiện đồng bộ danh mục Phí, lệ phí trước khi thực hiện gửi số liệu sang phần mềm Quản lý ngân sách tại đây',
    WarningNodataMission: 'Chưa phát sinh số liệu thực hiện Nhiệm vụ chi.',
    ErrorMission:
      'Vui lòng thực hiện đồng bộ danh mục Nhiệm vụ trước khi thực hiện gửi số liệu sang phần mềm Quản lý ngân sách tại đây',
    SuccessdataBudgetFees: 'Gửi số liệu thực hiện thu Phí, lệ phí thành công!',
    WarningNodataProject: 'Chưa phát sinh số liệu thực hiện CTMT, dự án.',
    ErrorProject:
      'Vui lòng thực hiện đồng bộ danh mục CTMT, dự án trước khi thực hiện gửi số liệu sang phần mềm Quản lý ngân sách tại đây',
    SuccessdataProject: 'Gửi số liệu thực hiện CTMT, dự án thành công!',
    ErrordataProject: 'Gửi số liệu thực hiện CTMT, dự án không thành công. Vui lòng thực hiện lại.',
    WarningNodataActive: 'Chưa phát sinh số liệu thực hiện Hoạt động.',
    ErrorActive:
      'Vui lòng thực hiện đồng bộ danh mục Hoạt động trước khi thực hiện gửi số liệu sang phần mềm Quản lý ngân sách tại đây',
    SuccessdataActive: 'Gửi số liệu thực hiện Hoạt động thành công!',
    SuccessdataMission: 'Gửi số liệu thực hiện Nhiệm vụ thành công!',
    ErrordataMission: 'Gửi số liệu thực hiện Nhiệm vụ không thành công. Vui lòng thực hiện lại.',
    ErrordataBudgetFees: 'Gửi số liệu thực hiện Phí, lệ phí không thành công. Vui lòng thực hiện lại.',
    ErrordataActive: 'Gửi số liệu thực hiện Hoạt động không thành công. Vui lòng thực hiện lại.',
    NoDataFees: 'Trên phần mềm QLNS không tồn tại danh mục phí, lệ phí. Vui lòng kiểm tra lại',
    NoDataActive: 'Trên phần mềm QLNS không tồn tại danh mục hoạt động. Vui lòng kiểm tra lại',
    NoDataMission: 'Trên phần mềm QLNS không tồn tại danh mục nhiệm vụ. Vui lòng kiểm tra lại',
    NoDataProject: 'Trên phần mềm QLNS không tồn tại danh mục CTMT, dự án. Vui lòng kiểm tra lại',
    DoNotExitsFees: 'Không tồn tại danh mục phí, lệ phí',
    DoNotExitsActive: 'Không tồn tại danh mục hoạt động',
    DoNotExitsMission: 'Không tồn tại danh mục nhiệm vụ',
    DoNotExitsProject: 'Không tồn tại danh mục CTMT, dự án',
    InValidUnFollow: 'Ngừng theo dõi không thành công',
    FromYearLessThanToYear: 'Từ năm phải nhỏ hơn đến năm.',
    SuccessUploadBgDesign: 'Tải lên hình nền thành công',
    ErrorUploadBgDesign: 'Tải lên hình nền thất bại',
    ValidateErrorParentId:
      '{0} <span class="color-green">{1}</span> là con của {2} <span class="color-green">{3}</span>. Vui lòng chọn lại.',
    SendEmailFail: 'Gửi email không thành công',
    MsgOverUser:
      'Số lượng người dùng tối đa <b>{0}</b> là <b>{1}</b> người dùng. Số lượng người dùng đang vượt quá số lượng đăng ký. Vui lòng liên hệ quản trị hệ thống <b>{2}</b> để được tiếp tục sử dụng.',
    DeleteAsset:
      'Tài sản <span class="color-green">{0}</span> ghi tăng sau ngày <span class="color-green">{1}</span> nên không đủ điều kiện ghi giảm.',
    DeleteBudgetChapter:
      'Chương <span class="color-green">{0}</span> đang được chọn làm chương ngầm định trong thiết lập tùy chọn',
    DeleteBudgetKindItem: 'Không được chọn loại khoản <span class="color-green">{0}</span> thuộc chính nó',
    DeleteBudgetKindItemDefault:
      'Khoản <span class="color-green">{0} - {1}</span> đang được chọn làm khoản ngầm định trong thiết lập tùy chọn',
    BudgetKindItemChangeToParent:
      'Bạn đang chọn loại - khoản chuyển đến là loại - khoản tổng hợp <span class="bold" style="color: #0eac13"> {0}</span>, để thực hiện chuyển loại - khoản cho loại - khoản này bạn phải chọn xóa loại - khoản sau khi chuyển và phải chọn loại - khoản chuyển đi gồm tất cả các loại - khoản chi tiết của loại - khoản <span class="bold" style="color: #0eac13"> {1}</span>.',
    BudgetKindItemChangeToParentOther:
      'Bạn đang chọn loại - khoản chuyển đến là loại - khoản tổng hợp <span class="bold" style="color: #0eac13"> {0}</span>, để thực hiện chuyển loại - khoản cho loại - khoản này bạn phải chọn xóa loại - khoản chi tiết của loại - khoản <span class="bold" style="color: #0eac13"> {1}</span>.',
    BudgetSourceValidateParent: 'Không được chọn nguồn kinh phí <span class="color-green">{0}</span> thuộc chính nó',
    BudgetSourceCannotDelete:
      'Nguồn kinh phí <span class="color-green">{0} - {1}</span> đang được chọn làm nguồn kinh phí ngầm định trong thiết lập tùy chọn',
    BudgetSourceChangeToParent:
      'Bạn đang chọn nguồn chuyển đến là nguồn tổng hợp <span class="bold" style="color: #0eac13"> {0}</span>, để thực hiện chuyển nguồn cho nguồn này bạn phải chọn xóa nguồn sau khi chuyển và phải chọn nguồn chuyển đi gồm tất cả các nguồn chi tiết của nguồn <span class="bold" style="color: #0eac13"> {1}</span>.',
    BudgetSourceChangeToParentOther:
      'Bạn đang chọn nguồn chuyển đến là nguồn tổng hợp <span class="bold" style="color: #0eac13"> {0}</span>, để thực hiện chuyển nguồn cho nguồn này bạn phải chọn xóa nguồn chi tiết của nguồn <span class="bold" style="color: #0eac13"> {1}</span>.',
    ProjectChangeToParent:
      'Bạn đang chọn CTMT/Dự án chuyển đến là CTMT/Dự án tổng hợp <span class="bold" style="color: #0eac13"> {0}</span>, để thực hiện chuyển CTMT/Dự án cho CTMT/Dự án này bạn phải chọn xóa loại khoản sau khi chuyển và phải chọn CTMT/Dự án chuyển đi gồm tất cả các CTMT/Dự án chi tiết của CTMT/Dự án <span class="bold" style="color: #0eac13"> {1}</span>.',
    ProjectChangeToParentOther:
      'Bạn đang chọn CTMT/Dự án chuyển đến là CTMT/Dự án tổng hợp <span class="bold" style="color: #0eac13"> {0}</span>, để thực hiện chuyển CTMT/Dự án cho CTMT/Dự án này bạn phải chọn xóa loại khoản chi tiết của CTMT/Dự án <span class="bold" style="color: #0eac13"> {1}</span>.',
    SystemAccoutnsTransferCannotTransferAccount:
      'Không thể chuyển đổi được số dư; phát sinh trên chứng từ do tài khoản <span class="color-green">{0}</span> có thông tin "Chi tiết theo" khác tài khoản <span class="color-green"><{1}></span><br><br>Không thể chuyển đổi tài khoản',
    SystemAccoutnsTransferChangeToParent:
      'Bạn đang chọn tài khoản chuyển đến là tài khoản tổng hợp <span class="bold" style="color: #0eac13"> {0}</span>, để thực hiện chuyển tài khoản hạch toán cho tài khoản này bạn phải chọn xóa tài khoản sau khi chuyển và phải chọn tài khoản chuyển đi gồm tất cả các tài khoản chi tiết của tài khoản <span class="bold" style="color: #0eac13"> {1}</span>.',
    SystemAccoutnsTransferChangeToParentOther:
      'Bạn đang chọn tài khoản chuyển đến là tài khoản tổng hợp <span class="bold" style="color: #0eac13"> {0}</span>, để thực hiện chuyển tài khoản hạch toán cho tài khoản này bạn phải chọn xóa tài khoản chi tiết của tài khoản <span class="bold" style="color: #0eac13"> {1}</span>.',
    TypeOfFundDelete:
      'Loại quỹ <span class="color-green">{0}</span> đang được chọn làm loại quỹ ngầm định trong thiết lập tùy chọn',
    financeReportSettingSetupFormula:
      'Chương trình đã áp dụng mẫu báo cáo <b>{0}</b> của đơn vị <b>{1}</b> thành công.',
    CancellingInvoiceSubmit:
      'Bạn không thể hủy hóa đơn <span class="color-blue">{0} - {1} - {2}</span> do đã có thông báo sai sót gửi cơ quan thuế với hình thức xử lý là Điều chỉnh',
    PaRetroSalaryDeleteNotSuccess: '<span class="color-blue">{0}</span> đã sinh chứng từ liên quan, không thể xóa.',
    PaSalaryAllocationDelete: 'Bạn không thể xóa dòng. Cần phải có ít nhất một dòng phân bổ cho bộ khoản lương {0}',
    PaSalaryAllocationPayroll: 'Phân bổ nguồn tại khoản lương <span class="color-blue">{0}</span> bị trùng lặp',
    BuPlanImportPopupimported: 'Dự toán năm {0} - Chương {1} đã được nhập. Vui lòng kiểm tra lại.',
    CloneDataSuccess: 'Sao lưu dữ liệu kế toán <span style="color: #0078d7">{0}</span> thành công.',
    M05SaveFailTitle:
      'Thông tin <span class="color-green">{0}</span> của chứng từ <span class="color-green">{1}</span> không được bỏ trống. Vui lòng xóa chứng từ này để lập lại.',
    M05TreasurySaveNotNull:
      'Các thông tin Đơn vị nhận tiền của chứng từ <span class="color-green">{0}</span> không được để trống. Vui lòng cập nhật lại trên danh mục và trên chứng từ.',
    M05CashSaveNotNull:
      'Các thông tin Người nhận tiền của chứng từ <span class="color-green">{0}</span> không được để trống. Vui lòng cập nhật lại trên danh mục và trên chứng từ.',
    M05OtherSaveNotNull:
      'Tổng nội dung các thông tin của Người nhận tiền trên chứng từ <span class="color-green">{0}</span> không được vượt quá 70 ký tự. Vui lòng kiểm tra lại.',
    PaRetroSalaryDeleteRetro:
      'Bảng lương truy lĩnh tháng {0} đã phát sinh số liệu trên bảng lương, bạn cần tính lại bảng lương tương ứng.',
    PaRetroDeleteNotSuccess: '<span class="color-blue">{0}</span> đã sinh chứng từ liên quan.',
    StatisticalDayOffDelete:
      'Bảng tổng hợp ngày nghỉ/làm thêm, làm đêm tháng {0} đã phát sinh số liệu trên bảng lương, bạn cần tính lại bảng lương tương ứng.',
    IsSummaryInvoiceBot: 'Bạn có muốn cộng gộp các dòng chi tiết không?',
    ExpiredQLTSConnected:
      '<div>Không kết nối được <span class="color-green">MISA QLTS</span> do đơn vị đã hết quyền sử dụng.</div><div>Vui lòng mua gói/gia hạn để tiếp tục sử dụng <a target="_blank" style="color: #0078D7; text-decoration: underline;" href="{0}">tại đây</a>.</div>',
    PaOtherOutComeDelete:
      'Bảng khấu trừ không thường xuyên tháng {0} đã phát sinh số liệu trên bảng lương, bạn cần tính lại bảng lương tương ứng.',
    NotificationOfSuccessfullRenewval:
      '<b>Kính gửi quý vị,</b><div class="mt-1">Công ty Cổ phần MISA xin chân thành cảm ơn Quý vị đã tin tưởng, lựa chọn phần mềm MISA Mimosa Online. Chúng tôi xin trân trọng thông báo Quý vị đã thực hiện gia hạn thành công giấy phép sản phẩm.</div><div class="mt-1">Thời hạn thuê bao: Từ <b>{0}</b> đến ngày <b>{1}</b>.</div>Quý đơn vị có thể xem lại lịch sử đăng ký gia hạn <a class="help-view-here" href="{2}" target="_blank" >tại đây</a>',
    FaVoucherDataGenerate:
      'Dữ liệu <span class="color-green">{0}</span> đang không được tích sử dụng hoặc không có trong danh mục. Vui lòng vào Danh mục để kiểm tra lại. Xem hướng dẫn <span class="text-link customCallBack">tại đây</span>.',
    FaVoucherDataGetDataFixedAssetQlts:
      'Dữ liệu <span class="color-green">{0}</span> đang không được tích sử dụng hoặc không có trong danh mục. Vui lòng vào Danh mục để kiểm tra lại. Xem hướng dẫn <span class="text-link customCallBack">tại đây</span>.',
    ConvertAcceptProcess:
      'Bạn không thể thực hiện sao lưu <span class="bold">{0}</span> vì đã vượt quá {1} lần sao lưu. Vui lòng kiểm tra danh sách Sao lưu và phục hồi dữ liệu để xóa bớt.',
  },
  MessageDeleteParentNode: {
    DeleteWarningParentTitle: 'Xóa không thành công',
    DeleteWarningParentContent: 'Không thể xóa danh mục cha nếu chưa xóa danh mục con.',
  },
  Voucher: {
    GenerateVoucher:
      'Không sinh được giấy rút dự toán từ hạch toán chi tiết của chứng từ này. Vui lòng kiểm tra lại dữ liệu cột TK Có và cột Nghiệp vụ.',
    GenerateVoucherTitle: 'Không hợp lệ',
    ConfirmSyncVocherContent:
      'Bạn có muốn đồng bộ các thông tin đã cập nhật trên chứng từ {0} này sang giấy rút dự toán số <span class="color-green">{1}</span> không?',
    ConfirmSyncVocherTitle: 'Đồng bộ chứng từ',
    ConfirmSyncFundSalaryContent:
      'Bạn có muốn đồng bộ các thông tin đã cập nhật trên chứng từ {0} này sang Chứng từ nghiệp vụ khác số <span class="color-green">{1}</span> không?',
  },
  BUPlanReceipt: {
    ValidateWarningAccountPostedTitle: 'Ghi sổ chứng từ',
    ValidateWarningAccountPostedMessage:
      'Tài khoản hạch toán không phù hợp với nguồn phát sinh. Bạn có muốn kiểm tra thông tin trước khi ghi sổ không?',
  },
  INAdjustmentDetail: {
    WarningGenerateOutward:
      'Chương trình đã sinh phiếu xuất kho <span class="color-green">{0}</span> để xử lý chênh lệch. Bạn không thể sinh thêm.',
    WarningGenerateInward:
      'Chương trình đã sinh phiếu nhập kho <span class="color-green">{0}</span> để xử lý chênh lệch. Bạn không thể sinh thêm.',
    TitleConfirmEditAdjustment: 'Sửa chứng từ',
    ConfirmEditAdjustment:
      'Điều chỉnh tồn kho đã có chứng từ xử lý chênh lệch <span class="color-green">&lt;{0}&gt;</span>. Bạn có muốn sửa không?',
    ValidateActionInWard: 'Bạn phải có ít nhất một vật tư, hàng hóa có hành động xử lý là Nhập Kho.',
    ValidateActionOutWard: 'Bạn phải có ít nhất một vật tư, hàng hóa có hành động xử lý là Xuất Kho.',
    ValidateNewQuantityAndAmonntControlGrid: 'Không thể điều chỉnh vừa tăng vừa giảm cho 1 vật tư trong kho.',
    validateDuplicateInventoryItemCodeGrid: 'Mã hàng đã có trong danh sách. Xin vui lòng kiểm tra lại.',
  },
  DefaultValue: {
    All: 'Tất cả',
  },
  Notification: {
    StartCalculateExportStock: 'Bắt đầu thực hiện tính giá xuất kho từ ngày <b>{0}</b> đến ngày <b>{1}</b>',
    CompleteCalculateExportStock: 'Hoàn thành việc Tính giá xuất kho từ ngày <b>{0}</b> đến ngày <b>{1}</b>',
    PostbathStatus:
      '<span class="color-green">{0}</span> {1} chứng từ ngày <b>{2}</b> đến <b>{3}</b> của các phân hệ <b>{4}</b>',
    CompleteCalculatePrice: 'Hoàn thành việc Tính giá xuất kho',
    PostbathTypeStatus: '{0} {1} chứng từ ngày <b>{2}</b> đến <b>{3}</b> của các phân hệ <b>{4}</b>.',
    StartCloseBook: 'Bắt đầu khóa sổ kỳ kế toán',
    CompleteCloseBook: 'Đã hoàn thành khóa sổ kỳ kế toán',
    NotPostedCloseBook: 'Khóa sổ kế toán không thành công do có chứng từ chưa được ghi sổ.',
    RebuildStatus: '<span class="color-green"><b>{0}</b></span> bảo trì dữ liệu từ ngày <b>{1}</b> đến ngày <b>{2}</b>',
    ErrorMes: 'Có một số lỗi đã xảy ra trong quá trình {0}',
    ConvertDataError:
      'Có một số lỗi đã xảy ra trong quá trình chuyển đổi dữ liệu <b>{0}</b> từ <b>MISA Mimosa 2022</b> phiên bản <b>{1}</b> lên dữ liệu <b>{2}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    CompleteConvertData:
      '<b><span class="color-green">Đã hoàn thành</span></b> chuyển đổi dữ liệu <b>{0}</b> từ <b>MISA Mimosa 2022</b> phiên bản <b>{1}</b> lên dữ liệu <b>{2}</b>',
    WarningExpiredDate:
      '<b>Thời hạn sử dụng còn {0} ngày</b><br><span>Kính đề nghị Quý khách hàng đăng ký gia hạn thuê bao</span>',
    EndCreateData: '<b><span class="color-green">Đã hoàn thành</span></b> thêm mới dữ liệu <b>{0}</b> từ <b>{1}</b>',
    ErrorCreateData: 'Có lỗi xảy ra khi tạo dữ liệu',
    ConvertAccountingSystemSuccess:
      '<b class="unwrapper-click"><span class="color-green">Đã hoàn thành</span></b> cập nhật Thông tư 24/2024/TT-BTC cho dữ liệu <b>{0}</b> từ dữ liệu <b>{1}</b>.',
    ConvertAccountingSystemError:
      'Có một số lỗi xảy ra trong quá trình cập nhật Thông tư 24/2024/TT-BTC cho dữ liệu <b>{0}</b> từ dữ liệu <b>{1}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    CompleteRestoreData: '<b><span class="color-green text-primary">Đã hoàn thành</span></b> phục hồi <b>{0}</b>.',
    CompleteBackupData: '<b><span class="color-green text-primary">Đã hoàn thành</span></b> sao lưu <b>{0}</b>.',
    CompleteRestoreStoredData:
      '<b><span class="color-green text-primary">Đã hoàn thành</span></b> phục hồi dữ liệu <b>{0}</b>.',
    CompleteStoreData: '<b><span class="color-green text-primary">Đã hoàn thành</span></b> lưu trữ dữ liệu <b>{0}</b>.',
    ErrorRestoreData:
      'Có một số lỗi đã xảy ra trong quá trình phục hồi dữ liệu <b>{0}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    ErrorBackupData:
      'Có một số lỗi đã xảy ra trong quá trình sao lưu dữ liệu <b>{0}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    ErrorRestoreStoredData:
      'Có một số lỗi đã xảy ra trong quá trình phục hồi dữ liệu <b>{0}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    ErrorStoreData:
      'Có một số lỗi đã xảy ra trong quá trình lưu trữ dữ liệu <b>{0}</b>. Vui lòng liên hệ MISA để được hỗ trợ.',
    CopyDataStart:
      '<b><span class="color-green">Bắt đầu</span></b> sao chép dữ liệu từ <span class="bold">{0}</span> đến dữ liệu <span class="bold">{1}</span>.',
    CopyDataComplete: `<b><span class="color-green">Hoàn thành</span></b> sao chép dữ liệu từ <span class="bold">{0}</span> đến dữ liệu <span class="bold">{1}</span>.`,
    AnnounceUpgrade: `Thông báo <b>nâng cấp hệ thống Mimosa Online</b> từ <b>{0}</b> ngày <b>{1}</b> đến <b>{2}</b> ngày <b>{3}</b>.`,
    SynchronyDataOffline: 'Hoàn tất đồng bộ dữ liệu ngoại tuyến',
  },

  TaxDeduction: {
    PostNotSuccess:
      'Hệ thống đã sinh chứng từ <span class="color-green">{0}</span> trong chứng từ nghiệp vụ khác và ghi sổ không thành công. Bạn có muốn xem chứng từ này không?',
    PostSuccess:
      'Hệ thống đã sinh chứng từ <span class="color-green">{0}</span> trong chứng từ nghiệp vụ khác và ghi sổ thành công. Bạn có muốn xem chứng từ này không?',
    TaxDeductionSuccessTitle: 'Sinh chứng từ thành công',
    TaxDeductionError: 'Không thực hiện được do đã khấu trừ thuế hoặc không có nghiệp vụ mua bán phát sinh trong kỳ',
    TaxDeductionErrorTitle: 'Khấu trừ không thành công',
  },

  ValidateMaintainDatabase: {
    Title: '{0} không thành công',
    Content:
      'Đang có lệnh bảo trì dữ liệu chưa hoàn thành: Lệnh bảo trì dữ liệu từ ngày <b>{0}</b> đến ngày <b>{1}</b> của dữ liệu <b>{2}</b>. Bạn không thể <b>{3}</b> đến khi nhận được thông báo hoàn thành bảo trì dữ liệu.',
    ContentAction:
      'Đang có lệnh bảo trì dữ liệu chưa hoàn thành: Lệnh bảo trì dữ liệu từ ngày <b>{0}</b> đến ngày <b>{1}</b> của dữ liệu <b>{2}</b>. Bạn không thể {3} <b>{4}</b> đến khi nhận được thông báo hoàn thành bảo trì dữ liệu.',
  },

  // Danh sách chứng từ chưa lập, cần nhắc nhở hàng tháng
  ListVoucherType: {
    BUPlanWithdrawSalary: 'Rút dự toán chuyển khoản lương',
    BUPlanWithdrawInsurance: 'Rút dự toán chuyển khoản thanh toán bảo hiểm',
    BUPlanWithdrawElectricity: 'Thanh toán tiền điện',
    BUPlanWithdrawWater: 'Rút dự toán chuyển khoản tiền nước',
    BUPlanWithdrawPhoneMoney: 'Rút dự toán chuyển khoản tiền điện thoại',
  },

  CompactCircularName: {
    Circulars2024: 'TT 24/2024/TT-BTC',
    Circulars2017: 'TT 107/2017/TT-BTC',
  },

  AppVersion: {
    TT107: 'v1',
    TT24: 'v3'
  }
};
